import CardItem from "components/alove/CardItem";
import { ActionSetting } from "layouts/screens/screenView/components/action";
import React, { useEffect, useState } from "react";

import { Action, Comm } from "models/content/Comm";
import { ScreenModel, ScreenType } from "models/content/Screen";
import { Autocomplete, Grid, IconButton, Tooltip } from "@mui/material";
import { AloveSwitch } from "components/alove/AloveSwitch";
import { ScreenPreview } from "layouts/screens/screenView/components/preview";
import { getScreen } from "utils/screenUtils";
import RefreshIcon from '@mui/icons-material/Refresh';

const MDInput = require("components/MDInput/index.js").default;
const MDButton = require("components/MDButton/index.js").default;

export const InappContainer = ({
  comm,
  setComm,
  screens,
  refreshScreens,
}: {
  comm: Comm;
  setComm: any;
  screens: ScreenModel[];
  refreshScreens: () => void;
}) => {
  const [screen, setScreen] = useState({} as ScreenModel);

  useEffect(() => {
    if (comm.inapp?.actionUrl) {
      getScreen(comm.inapp.actionUrl.toString()).then((s) => {
        setScreen(s);
      }
      );
    }
  }, [comm.inapp?.actionUrl]);

  useEffect(() => {
    if (!comm.inapp?.expirationDate) {
      setComm({ ...comm, inapp: { ...comm.inapp, expirationDate: new Date(Date.now() + 30*24*60*60*1000).toISOString().split('T')[0] } });
    }
  }, [comm.inapp]);

  return (
    <React.Fragment>
      <CardItem title="Edit In-App" id="comm" halfWidth>
        <Grid container spacing={1} rowGap={3}>
          <Grid size={6}>
            <Autocomplete
              value={screens.find((s) => s.id == comm.inapp?.actionUrl) || ({} as ScreenModel)}
              fullWidth
              getOptionLabel={(option: ScreenModel) => option.name}
              onChange={(e, o) => setComm({ ...comm, inapp: { ...comm.inapp, actionUrl: o?.id } })}
              options={screens.filter((s) => [ScreenType.Popup, ScreenType.Curtain].includes(s.type))}
              renderInput={(params) => <MDInput {...params} label="Screen" />}
            />
          </Grid>
          <Grid size={2}>
            <MDButton
              variant="outlined"
              color="info"
              fullWidth
              onClick={() => {
                window.open(`#/screens/${comm.inapp?.actionUrl || "new"}`, "_blank");
              }}
            >
              {" "}
              {comm.inapp?.actionUrl ? "Edit" : "Create"}{" "}
            </MDButton>
          </Grid>
          <Grid size={2}>
            <Tooltip title="Refresh screens list">
              <IconButton 
                color="info" 
                onClick={refreshScreens}
                size="small"
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid size={12}>
          <AloveSwitch
            title="Dismissable"
            value={comm.inapp?.dismissable || false}
            setValue={(v) => {
              setComm({ ...comm, inapp: { ...comm.inapp, dismissable: v } });
            }}
            subtitle="Dismissable in-app messages allow users to dismiss the message without taking any action."
          />
          </Grid>
          <Grid size={6}>
            <MDInput
              label="Expiration Date"
              type="date"
              value={comm.inapp?.expirationDate}
              fullWidth
              onChange={(e) => {
                setComm({ ...comm, inapp: { ...comm.inapp, expirationDate: e.target.value } });
              }
              }
            />
            </Grid>
        </Grid>
      </CardItem>
      <CardItem title="Preview" id="comm-preview" halfWidth>
        <ScreenPreview
          screen={screen}
          colors={[]}
          />
        </CardItem>
    </React.Fragment>
  );
};
